const riot = require('riot');

riot.tag2('module-bio', '<h2 class="fs30 mb8">{opts.bio.title}</h2> <div class="row {&quot;flex-row-reverse&quot; : opts.index % 2 === 0}"> <div class="col6 s-col12 px8 bg-Black30 p32 text-whiter f flex-column fc opacity-0 box-shadow" data-reveal-class="fadein-bottom"> <h3 class="mb16" if="{subtitle}">- {subtitle} -</h3> <ul class="pb4" each="{item in opts.bio.items}"> <li class="fs12 text-softgray list-style-type-none">{item.description}</li> </ul> </div> <div class="col6 s-col12 px8 f fh opacity-0 s-px0" data-reveal-class="fadein-bottom-text"><img class="block s-full object-fit-cover" riot-src="{opts.bio.image}"></div> </div>', '', '', function(opts) {
    this.on('mount', () => {
      this.subtitle = {
        mv_or_cm: '',
        stage_or_backup: '',
        immersive_theater: '',
        narration: '',
        kemuri: 'KEMURI',
        other: 'その他',
        history: '過去の経歴(2013~2018)',
      }[this.opts.bio.kind];

      if (spat.isBrowser) {
        app.utils.observeAnimationElement(this.root);
      }
      this.update();
    });
});